module.exports = __webpack_public_path__ + "static/background-2d00d4fca6eb8566a6217f9fef7d5b19.jpg";